import { render, staticRenderFns } from "./CheckBox.component.vue?vue&type=template&id=6fcf06c4&scoped=true&"
import script from "./CheckBox.component.vue?vue&type=script&lang=js&"
export * from "./CheckBox.component.vue?vue&type=script&lang=js&"
import style0 from "./CheckBox.component.vue?vue&type=style&index=0&id=6fcf06c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf06c4",
  null
  
)

export default component.exports